import { jsx as _jsx } from "react/jsx-runtime";
import { Spinner } from "@air/primitive-spinner";
import { memo, useEffect, useRef } from "react";
import { useInView } from "react-intersection-observer";
export const KanbanColumnLoadMoreItems = /*#__PURE__*/ memo((param)=>{
    let { loadMore, isLoading } = param;
    const { ref, inView } = useInView({
        threshold: 0.01,
        rootMargin: "300px"
    });
    const isLoadingRef = useRef(isLoading);
    isLoadingRef.current = isLoading;
    useEffect(()=>{
        if (inView && !isLoadingRef.current) {
            loadMore();
        }
    }, [
        inView,
        loadMore
    ]);
    return /*#__PURE__*/ _jsx("div", {
        ref: ref,
        className: "flex h-[150px] items-center justify-center py-1.5",
        children: /*#__PURE__*/ _jsx(Spinner, {
            className: "size-8 text-teal-9"
        })
    });
});
KanbanColumnLoadMoreItems.displayName = "KanbanColumnLoadMoreItems";
